import React from "react";

const StripeClientCancel = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <div className="bg-white shadow-lg rounded-2xl p-8 text-center max-w-md">
        <h2 className="text-3xl font-bold text-red-600 mb-4">
          Payment Cancelled ❌
        </h2>
        <p className="text-gray-700 mb-6">
          Your payment has been cancelled. Please try again or contact support <br/>if you need help.
        </p>
      </div>
    </div>
  );
};

export default StripeClientCancel;
